var _style, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 25",
    style: {
      enableBackground: "new 0 0 20 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6D69EF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.2,10.1c0-5-3.6-8.5-8.2-8.5s-8.2,3.6-8.2,8.5c0,3.2,2.7,7.5,8.2,12.6C15.6,17.5,18.2,13.3,18.2,10.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,0C4.8,0,0,4,0,10.2c0,4.1,3.3,9,10,14.8c6.6-5.7,10-10.6,10-14.8C20,4,15.2,0,10,0z M10,21.6C4.9,17,2.5,13.1,2.5,10.2 c0-4.6,3.3-7.8,7.5-7.8s7.5,3.2,7.5,7.8C17.5,13.1,15.1,17,10,21.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.b707e91969fddb9f4f6368ec5a96c98a.svg";
export { ForwardRef as ReactComponent };